'use strict';
var listeners = {};
var $window = $(window);
var removeListener = function(listenerName) {
    if (listeners[listenerName]) {
        delete listeners[listenerName];
    }
};

module.exports = {
    startScrollListener: function() {
        Odigeo.on('routeChange', function(route) {
            _.each(listeners, function(listener) {
                if (route.from.name === listener.pageName) {
                    removeListener(listener.name);
                }
            });
        });
        $window.on(Odigeo.Events.scroll, _.throttle(function() {
            var scrollPos = $window.scrollTop();
            _.each(listeners, function(listener) {
                if (scrollPos >= listener.start && (!listener.end || scrollPos <= listener.end) ) {
                    listener.fn();
                    if (listener.justOnce) {
                        removeListener(listener.name);
                    }
                }
            });
        }, 100, true));
    },
    addScrollListener: function(options) {
        if (!listeners[options.name] && options.name) {
            listeners[options.name] = _.extend({
                pageName: 'all',
                fn: '',
                start: 0,
                end: 0,
                justOnce: false,
            }, options);
        }
    },
    removeScrollListener: removeListener,
    getRelativeScreenPosition: function($element) {
        return $element.offset().top - $window.scrollTop();
    },
    calculateScroll: function() {
        var scrollTop = $(document).scrollTop();
        var windowHeight = $window.height();
        var bodyHeight = $(document).height() - windowHeight;
        return scrollTop / bodyHeight;
    },
};
